"use client";

import { c as _c } from "react/compiler-runtime";
import { deleteComment } from "@/actions/comment";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import ButtonWithLoader from "@/components/utility/button-with-loader";
import { queryClient } from "@/providers/react-query";
import { getReplies } from "@/queries-alt/with-use-server";
import { tryCatch } from "@/utils/validators";
import { MoreHorizontal, Trash } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
type ReplyMenuProps = {
  reply: Awaited<ReturnType<typeof getReplies>>["replies"][number];
};
export default function ReplyMenu(t0) {
  const $ = _c(15);
  const {
    reply
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  let t1;
  if ($[0] !== reply.id || $[1] !== reply.parentCommentId) {
    t1 = async function handleDeleteReply() {
      setIsDeleting(true);
      const {
        error
      } = await tryCatch(deleteComment(reply.id));
      if (error) {
        toast.error(error.message);
        return;
      }
      setIsDeleting(false);
      setIsOpen(false);
      queryClient.invalidateQueries({
        queryKey: [`get-replies:${reply.parentCommentId}`]
      });
      toast.success("Reply deleted.");
    };
    $[0] = reply.id;
    $[1] = reply.parentCommentId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDeleteReply = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className="absolute right-2 top-0 h-8 w-8 p-0"><MoreHorizontal className="h-4 w-4" /></Button></DropdownMenuTrigger>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenu>{t2}<DropdownMenuContent><DropdownMenuItem onClick={() => setIsOpen(true)}><Trash className="mr-2 h-4 w-4" /> Delete</DropdownMenuItem></DropdownMenuContent></DropdownMenu>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AlertDialogHeader><AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle><AlertDialogDescription>This action cannot be undone. It will permanently delete this reply.</AlertDialogDescription></AlertDialogHeader>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AlertDialogCancel>Cancel</AlertDialogCancel>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleDeleteReply) {
    t6 = () => handleDeleteReply();
    $[7] = handleDeleteReply;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isDeleting || $[10] !== t6) {
    t7 = <AlertDialogContent>{t4}<AlertDialogFooter>{t5}<ButtonWithLoader onClick={t6} pending={isDeleting}>Delete</ButtonWithLoader></AlertDialogFooter></AlertDialogContent>;
    $[9] = isDeleting;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isOpen || $[13] !== t7) {
    t8 = <>{t3}<AlertDialog open={isOpen} onOpenChange={setIsOpen}>{t7}</AlertDialog></>;
    $[12] = isOpen;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}